import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiJava,
  SiJavascript,
  SiPython,
  SiCplusplus,
  SiPostgresql,
  SiOracle,
  SiMysql,
  SiMicrosoftsqlserver,
  SiMongodb,
} from "react-icons/si";

const languages = [
  { label: "Java", icon: <SiJava /> },
  { label: "PostgreSQL", icon: <SiPostgresql /> },
  { label: "Oracle", icon: <SiOracle /> },
  { label: "MySQL", icon: <SiMysql /> },
  { label: "SQL Server", icon: <SiMicrosoftsqlserver /> },
  { label: "MongoDB", icon: <SiMongodb /> },
  { label: "JavaScript", icon: <SiJavascript /> },
  { label: "Python", icon: <SiPython /> },
  { label: "C++", icon: <SiCplusplus /> },
];

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {languages.map((item) => (
        <Col xs={4} md={2} className="tech-icons" key={item.label}>
          {item.icon}
          <div className="tech-label">{item.label}</div>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
